/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.storeLocator = (await import('./pages/store-locator/StoreLocatorContainer')).StoreLocatorContainer;
    Components.storeLocatorMobile = (await import('./pages/store-locator/StoreLocatorMobileContainer')).StoreLocatorMobileContainer;
    Components.homeServices = (await import('./pages/home-services/HomeServicesContainer')).HomeServicesContainer;
    Components.rentalServices = (await import('./pages/rental-services/RentalServicesContainer')).RentalServicesContainer;
    Components.gardenCenter = (await import('./pages/garden-center/GardenCenterContainer')).GardenCenterContainer;
    Components.proDesk = (await import('./pages/pro-desk/ProDeskContainer')).ProDeskContainer;
    Components.storeReviews = (await import('./pages/store-reviews/ReviewsContainer')).ReviewsContainer;
    Components.storeDetails = (await import('./pages/store-details/DetailsContainer')).DetailsContainer;
    Components.storeDirectory = (await import('./pages/store-directory/DirectoryContainer')).DirectoryContainer;
    Components.localCity = (await import('./pages/local-city/LocalCityContainer')).LocalCityContainer;
    Components.stateDirectory = (await import('./pages/store-directory/StateDirectoryContainer')).StateDirectoryContainer;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  storeLocator: {
    name: 'StoreLocatorContainer',
    componentName: 'StoreLocatorContainer',
    chunk: () => import('./pages/store-locator/StoreLocatorContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.storeLocator
        : currentRouteName === 'StoreLocatorContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'desktop'
  },

  storeLocatorMobile: {
    name: 'StoreLocatorMobileContainer',
    componentName: 'StoreLocatorMobileContainer',
    chunk: () => import('./pages/store-locator/StoreLocatorMobileContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.storeLocatorMobile
        : currentRouteName === 'StoreLocatorMobileContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorMobileContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'mobile'
  },

  homeServices: {
    name: 'HomeServicesContainer',
    componentName: 'HomeServicesContainer',
    chunk: () => import('./pages/home-services/HomeServicesContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.homeServices
        : currentRouteName === 'HomeServicesContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeServicesContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/services',
    varnish: true,
    channel: null
  },

  rentalServices: {
    name: 'RentalServicesContainer',
    componentName: 'RentalServicesContainer',
    chunk: () => import('./pages/rental-services/RentalServicesContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.rentalServices
        : currentRouteName === 'RentalServicesContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RentalServicesContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/rentals',
    varnish: true,
    channel: null
  },

  gardenCenter: {
    name: 'GardenCenterContainer',
    componentName: 'GardenCenterContainer',
    chunk: () => import('./pages/garden-center/GardenCenterContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.gardenCenter
        : currentRouteName === 'GardenCenterContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.GardenCenterContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/garden-center',
    varnish: true,
    channel: null
  },

  proDesk: {
    name: 'ProDeskContainer',
    componentName: 'ProDeskContainer',
    chunk: () => import('./pages/pro-desk/ProDeskContainer'),
    get component() {
      return ssr
        ? serverPages.proDesk
        : currentRouteName === 'ProDeskContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProDeskContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/pro-desk',
    varnish: true,
    channel: null
  },

  storeReviews: {
    name: 'ReviewsContainer',
    componentName: 'ReviewsContainer',
    chunk: () => import('./pages/store-reviews/ReviewsContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.storeReviews
        : currentRouteName === 'ReviewsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReviewsContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/reviews/:reviewPage?',
    varnish: true,
    channel: null
  },

  storeDetails: {
    name: 'DetailsContainer',
    componentName: 'DetailsContainer',
    chunk: () => import('./pages/store-details/DetailsContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.storeDetails
        : currentRouteName === 'DetailsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DetailsContainer })));
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber',
    varnish: true,
    channel: null
  },

  storeDirectory: {
    name: 'DirectoryContainer',
    componentName: 'DirectoryContainer',
    chunk: () => import('./pages/store-directory/DirectoryContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.storeDirectory
        : currentRouteName === 'DirectoryContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DirectoryContainer })));
    },
    path: '/:context?/l/storeDirectory',
    varnish: true,
    channel: null
  },

  localCity: {
    name: 'LocalCityContainer',
    componentName: 'LocalCityContainer',
    chunk: () => import('./pages/local-city/LocalCityContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.localCity
        : currentRouteName === 'LocalCityContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalCityContainer })));
    },
    path: '/:context?/l/:state/:city/:guid',
    varnish: true,
    channel: null
  },

  stateDirectory: {
    name: 'StateDirectoryContainer',
    componentName: 'StateDirectoryContainer',
    chunk: () => import('./pages/store-directory/StateDirectoryContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.stateDirectory
        : currentRouteName === 'StateDirectoryContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StateDirectoryContainer })));
    },
    path: '/:context?/l/:state',
    varnish: true,
    channel: null
  },
});
